<template>
  <div class="email-field-wrap">
    <StInput
      ref="email"
      :key="'login-email-field'"
      :value="email"
      :text-value="email"
      :label-text="'emailLabel'"
      :placeholder-text="'onboardingEmailPlaceholder'"
      :input-type="'text'"
      :error-message="'Please enter valid email address.'"
      :input-width="445"
      :input-height="46"
      @input="email = $event"
      @validate="validate"
      @enter-key="handleEnter"
    />
  </div>
</template>

<script>
import EventBus from '@/utilities/eventBus';
import validateEmail from '@/utilities/validateEmail';
import StInput from './StInput';

export default {
  name: 'EmailField',
  components: {
    StInput,
  },
  props: {
    foucusField: {
      type: Boolean,
      required: false,
    },
  },
  emits: ['enter-key'],
  computed: {
    email: {
      set(value) {
        this.setEmail(value);
      },
      get() {
        return this.$store.getters.getEmail;
      },
    },
  },
  mounted() {
    if (this.foucusField) {
      this.focusInput();
    }
    EventBus.$on('focusEmail', this.focusInput);
    this.email = '';
  },

  methods: {
    setEmail(value) {
      this.$store.dispatch('setEmail', value);
    },

    validate() {
      const value = validateEmail(this.$store.getters.getEmail);
      this.$refs.email?.handleValidation(!value);
      return !value;
    },

    focusInput() {
      if (this.$refs.email !== undefined) {
        this.$refs.email.focusInput();
      }
    },

    handleEnter() {
      this.$emit('enter-key');
    },
  },
};
</script>
